export default __webpack_public_path__ + "static/media/Angelo Brandini.028adb91.png";